import { render, staticRenderFns } from "./uploadcode.vue?vue&type=template&id=ec2b1b6a&scoped=true&"
import script from "./uploadcode.vue?vue&type=script&lang=js&"
export * from "./uploadcode.vue?vue&type=script&lang=js&"
import style0 from "./uploadcode.vue?vue&type=style&index=0&id=ec2b1b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2b1b6a",
  null
  
)

export default component.exports